<div class="container-fluid">
  <form *ngIf="paymentDataForm" [formGroup]="paymentDataForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12 mt-2">
        <h5 class="text-primary">Informations bancaires</h5>
      </div>
    </div>
    <div class="row mt-2">
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label class="required">Nom du titulaire</label>
        <input
          type="text"
          class="form-control"
          formControlName="holderLastName"
          (change)="formatUppercaseInput($event)"
          [class.is-invalid]="submitted && paymentDataForm.controls?.holderLastName?.errors"
        />
        <small *ngIf="submitted && paymentDataForm.controls?.holderLastName?.errors?.required" class="form-text text-danger"
          >Le nom du titulaire est requis.</small
        >
        <small *ngIf="submitted && paymentDataForm.controls?.holderLastName?.errors?.pattern" class="form-text text-danger"
          >Les chiffres et caractères spéciaux ne sont pas autorisés.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label class="required">Prénom du titulaire</label>
        <input
          type="text"
          class="form-control"
          formControlName="holderFirstName"
          (change)="formatUppercaseInput($event)"
          [class.is-invalid]="submitted && paymentDataForm.controls?.holderFirstName?.errors"
        />
        <small *ngIf="submitted && paymentDataForm.controls?.holderFirstName?.errors?.required" class="form-text text-danger"
          >Le prénom du titulaire est requis.</small
        >
        <small *ngIf="submitted && paymentDataForm.controls?.holderFirstName?.errors?.pattern" class="form-text text-danger"
          >Les chiffres et caractères spéciaux ne sont pas autorisés.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
        <label class="required">Domiciliation bancaire</label>
        <input
          type="text"
          class="form-control"
          formControlName="bankName"
          (change)="formatUppercaseInput($event)"
          [class.is-invalid]="submitted && paymentDataForm.controls?.bankName?.errors"
        />
        <small *ngIf="submitted && paymentDataForm.controls?.bankName?.errors?.required" class="form-text text-danger"
          >La domiciliation bancaire est requise.</small
        >
        <small *ngIf="submitted && paymentDataForm.controls?.bankName?.errors?.pattern" class="form-text text-danger"
          >Les chiffres et caractères spéciaux ne sont pas autorisés.</small
        >
      </div>
    </div>
    <div class="row">
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
        <label class="required">IBAN</label>
        <input
          type="text"
          class="form-control"
          formControlName="iban"
          (focusout)="formatIbanInput($event)"
          [class.is-invalid]="submitted && paymentDataForm.controls?.iban?.errors"
        />
        <small *ngIf="submitted && paymentDataForm.controls?.iban?.errors?.required" class="form-text text-danger">Le numéro IBAN est requis.</small>
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label class="required">BIC / SWIFT</label>
        <input
          type="text"
          class="form-control"
          formControlName="bic"
          (change)="formatUppercaseInput($event)"
          [class.is-invalid]="submitted && paymentDataForm.controls?.bic?.errors"
        />
        <small *ngIf="submitted && paymentDataForm.controls?.bic?.errors?.required" class="form-text text-danger"
          >Le code BIC / SWIFT est requis.</small
        >
      </div>
      <div class="mb-3 text-secondary col-6 col-lg-6 col-xl-3">
        <label class="required">Livret A ?</label>
        <div class="mb-3 text-secondary">
          <div class="d-flex flex-row justify-content-start my-2">
            <div class="form-check form-check-inline">
              <input
                id="aYes"
                type="radio"
                class="form-check-input"
                formControlName="livretA"
                name="livretA"
                [class.is-invalid]="submitted && paymentDataForm.controls?.livretA?.errors"
                [value]="true"
              />
              <label for="aYes" class="form-check-label">Oui</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                id="aNo"
                type="radio"
                class="form-check-input"
                formControlName="livretA"
                name="livretA"
                [class.is-invalid]="submitted && paymentDataForm.controls?.livretA?.errors"
                [value]="false"
              />
              <label for="aNo" class="form-check-label">Non</label>
            </div>
          </div>
          <small *ngIf="submitted && paymentDataForm.controls?.livretA?.errors?.required" class="form-text text-danger">Ce choix est requis.</small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
        <label class="required">Relevé d'identité bancaire</label>
        <app-file-input
          formControlName="pdf"
          [beneficiary]="beneficiary"
          [invalid]="
            paymentDataForm.controls?.pdf?.errors?.fileType ||
            paymentDataForm.controls?.pdf?.errors?.fileSize ||
            (submitted && paymentDataForm.controls?.pdf?.errors)
          "
          title="RIB"
          accept="application/pdf"
          [maxFileSize]="maxFileSize"
        ></app-file-input>
        <small *ngIf="submitted && paymentDataForm.controls?.pdf?.errors?.required" class="form-text text-danger"
          >Le relevé d'identité bancaire est requis.</small
        >
        <small *ngIf="paymentDataForm.controls?.pdf?.errors?.fileType" class="form-text text-danger">Le document doit être de type PDF.</small>
        <small *ngIf="paymentDataForm.controls?.pdf?.errors?.fileSize" class="form-text text-danger">
          Le document ne doit pas dépasser {{ maxFileSizeStr }}.
        </small>
      </div>

      <div class="mb-3 text-secondary col-6 col-lg-6 col-xl-3">
        <label class="required">Visa ?</label>
        <div class="mb-3 text-secondary">
          <div class="d-flex flex-row justify-content-start my-2">
            <div class="form-check form-check-inline">
              <input
                id="visaYes"
                type="radio"
                class="form-check-input"
                formControlName="visa"
                name="Visa"
                [class.is-invalid]="submitted && paymentDataForm.controls?.visa?.errors"
                [value]="true"
              />
              <label for="visaYes" class="form-check-label">Oui</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                id="visaNo"
                type="radio"
                class="form-check-input"
                formControlName="visa"
                name="Visa"
                [class.is-invalid]="submitted && paymentDataForm.controls?.visa?.errors"
                [value]="false"
              />
              <label for="visaNo" class="form-check-label">Non</label>
            </div>
          </div>
          <small *ngIf="submitted && paymentDataForm.controls?.visa?.errors?.required" class="form-text text-danger">Ce choix est requis.</small>
        </div>
      </div>

      <div class="d-grid mb-3 col-12 col-lg-12 col-xl-2 mt-4 ms-auto">
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
          (click)="historize()"
        >
          Historiser
        </button>
      </div>
    </div>
    <!-- Tableau historique des informations bancaires -->
    <div class="card border-0 card-border-radius-0">
      <div class="card-body p-0">
        <div class="table-responsive">
          <div ngbAccordion [closeOthers]="false">
            <div ngbAccordionItem>
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="accordion-button text-secondary">
                  <span id="paymentInfoHistoryTitle">Informations bancaires historisées</span>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p *ngIf="historizedData.length === 0">Le bénéficiaire n'a aucune historisation d'information bancaire.</p>
                    <div class="col px-0 pt-2" *ngIf="historizedData.length !== 0">
                      <table class="table table-responsive table-striped table-hover" aria-describedby="paymentInfoHistoryTitle">
                        <thead class="text-secondary text-nowrap bg-light">
                          <tr>
                            <th scope="col" class="text-center"></th>
                            <th scope="col" class="text-center">Date de début</th>
                            <th scope="col" class="text-center">Date de fin</th>
                            <th scope="col" class="text-center">Nom</th>
                            <th scope="col" class="text-center">Prénom</th>
                            <th scope="col" class="text-center">Domiciliation bancaire</th>
                            <th scope="col" class="text-center">IBAN</th>
                            <th scope="col" class="text-center">BIC / SWIFT</th>
                            <th scope="col" class="text-center">Livret A</th>
                            <th scope="col" class="text-center">RIB</th>
                            <th scope="col" class="text-center">Visa</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let history of historizedData" class="text-nowrap">
                            <td class="text-center">
                              <ng-container *ngIf="!history.hasPayments">
                                <button
                                  type="button"
                                  (click)="deleteHistory(history)"
                                  *appOnlyGroups="['ADMIN', 'DIRECTION+']"
                                  class="btn btn-sm btn-primary"
                                  ngbTooltip="Supprimer"
                                >
                                  <fa-icon icon="trash-alt"></fa-icon>
                                </button>
                              </ng-container>
                            </td>
                            <td class="text-center">
                              {{ history.beginDate | date }}
                            </td>
                            <td class="text-center">
                              {{ history.endDate | date }}
                            </td>
                            <td class="text-center">
                              {{ history.holderLastName }}
                            </td>
                            <td class="text-center">
                              {{ history.holderFirstName }}
                            </td>
                            <td class="text-center">
                              {{ history.bankName }}
                            </td>
                            <td class="text-center">
                              {{ history.iban }}
                            </td>
                            <td class="text-center">
                              {{ history.bic }}
                            </td>
                            <td class="text-center">
                              {{ history.livretA ? 'Oui' : 'Non' }}
                            </td>
                            <td class="text-center">
                              {{ history.pdfName }}
                            </td>
                            <td class="text-center">
                              {{ history.visa ? 'Oui' : 'Non' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0 my-4">
      <div class="d-grid ms-auto col-md-6 col-3 col-lg-3 col-xl-2 px-0">
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          (click)="cancel()"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
        >
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-2 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 col-xl-2 pe-0">
        <button class="btn btn-primary d-flex justify-content-center" type="submit" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <fa-icon icon="save"></fa-icon>
          <span class="ms-2 d-none d-md-block">Sauvegarder</span>
        </button>
      </div>
    </div>
    <div>
      <app-rsj-payment-information [beneficiary]="beneficiary"></app-rsj-payment-information>
    </div>
  </form>
</div>
